import styled from 'styled-components';

import MQ from '../../attrs/mq';

export const Container = styled.div`
  box-sizing: border-box;
  margin: 1rem auto 3rem;
  padding: 0 1rem;
  max-width: 1400px;

  ${MQ.lg`
    padding: 0 2rem;
    margin-top: 2rem;
  `}
`;
